import { apiConfig } from "./apiConfig";

export const modelApi = apiConfig.injectEndpoints({
  endpoints: (builder) => ({
    getModelList: builder.query<
      any,
      {
        startKey: string;
        page_size?: number | string;
        brand_id: string | null;
        family_id: string | null;
      }
    >({
      query: ({ startKey, page_size, brand_id, family_id }) => ({
        url: `/v1/ap/admin/brand/${brand_id}/family/${family_id}/model`,
        params: {
          start_key: startKey,
          page_size: Number(page_size),
        },
      }),
      providesTags: ["Model"],
    }),

    createModel: builder.mutation<
      any,
      { brand_id: string | null; family_id: string | null; body: any }
    >({
      query: ({ body, brand_id, family_id }) => ({
        url: `/v1/ap/admin/brand/${brand_id}/family/${family_id}/model`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["Model"],
    }),

    getSingleModelDetails: builder.query<
      any,
      {
        brand_id: string | null;
        family_id: string | null;
        model_id: string | null;
      }
    >({
      query: ({ brand_id, family_id, model_id }) => ({
        url: `/v1/ap/admin/brand/${brand_id}/family/${family_id}/model/${model_id}`,
      }),
    }),

    editModel: builder.mutation<
      any,
      {
        brand_id: string | null;
        family_id: string | null;
        model_id: string | null;
        body: any;
      }
    >({
      query: ({ brand_id, body, family_id, model_id }) => ({
        url: `/v1/ap/admin/brand/${brand_id}/family/${family_id}/model/${model_id}`,
        method: "PUT",
        body: body,
      }),
      invalidatesTags: ["Model"],
    }),
  }),
});

export const {
  useLazyGetModelListQuery,
  useCreateModelMutation,
  useLazyGetSingleModelDetailsQuery,
  useEditModelMutation,
} = modelApi;
